//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productPic', {
//        templateUrl: 'views/components/views/productPic/productPic.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'productPicService', function ($stateParams, stateService, translateService, modalService, productPicService) {
//            const vm = this;
//            let productPictureBankKeyno = $stateParams.productpicturebank_keyno;
//            let prodId = $stateParams.prod_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadEdit() {
//                vm.model.edit = (await productPicService.getProductPicture({
//                    productpicturebank_keyno: productPictureBankKeyno,
//                    prod_id: prodId
//                }))[0];
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'picturebanks':
//                        go({
//                            argtype: 'prod_id',
//                            argvalue: vm.model.edit.prod_id
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productPicService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    productPicService.deleteItem(vm.model.edit).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }
//        }]
//    });
//})();
